import { render, staticRenderFns } from "./Attention.vue?vue&type=template&id=3dbfc7e0&scoped=true&"
import script from "./Attention.vue?vue&type=script&lang=js&"
export * from "./Attention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbfc7e0",
  null
  
)

export default component.exports